import*as e from"react";var r={S:{100:320,200:550},M:{100:768},L:{100:1024}};export{r as queries};
